"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClassroomActionEnum = void 0;
var ClassroomActionEnum;
(function (ClassroomActionEnum) {
  /** Могу изменить общие сведения */
  ClassroomActionEnum["edit"] = "edit";
  /** Могу пригласить участников */
  ClassroomActionEnum["invite"] = "invite";
  /** могу отозвать приглашение */
  ClassroomActionEnum["withdrawInvitation"] = "withdrawInvitation";
  /** Могу принять приглашение */
  ClassroomActionEnum["acceptInvitation"] = "acceptInvitation";
  /** Могу отклонить приглашение */
  ClassroomActionEnum["declineInvitation"] = "declineInvitation";
  /** Могу присоединиться (по ссылке) */
  ClassroomActionEnum["join"] = "join";
  /** Могу покинуть */
  ClassroomActionEnum["leave"] = "leave";
  /** Смогу присоединиться (по ссылке) после авторизации */
  ClassroomActionEnum["authJoin"] = "authJoin";
  /** Смогу присоединиться (по ссылке) с оплатой после авторизации */
  ClassroomActionEnum["authPaidJoin"] = "authPaidJoin";
  /** Могу архивировать */
  ClassroomActionEnum["archive"] = "archive";
  /** Могу восстановить из архива */
  ClassroomActionEnum["restore"] = "restore";
  /** Могу создать митинг */
  ClassroomActionEnum["schedule_meeting"] = "schedule_meeting";
  /** Могу управлять контентом в комнате */
  ClassroomActionEnum["manage_content"] = "manage_content";
  /** Могу назначать и проверять задания для участников комнаты */
  ClassroomActionEnum["manage_tasks"] = "manage_tasks";
  /** Могу назначать ассистента */
  ClassroomActionEnum["assign_assistant"] = "assign_assistant";
  /** Могу назначать преподавателя на замену */
  ClassroomActionEnum["assign_replacement_teacher"] = "assign_replacement_teacher";
  /** @deprecated */
  ClassroomActionEnum["join_user_service_contract"] = "join_user_service_contract";
  /** @deprecated */
  ClassroomActionEnum["break_user_service_contract"] = "break_user_service_contract";
  /** Могу пользоваться чатом */
  ClassroomActionEnum["chat"] = "chat";
})(ClassroomActionEnum = exports.ClassroomActionEnum || (exports.ClassroomActionEnum = {}));
